import ApplicationConf from 'conf/ApplicationConf'
import { fetchInstances } from 'supervision/instances/InstancesSlice'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ServicesActions } from 'supervision/services/ServicesSlice'
import TimeErrorFilterFields from 'supervision/timeErrors/components/TimeErrorFilterFields'
import TimeErrorsTable from 'supervision/timeErrors/components/TimeErrorsTable'
import useFetch from 'common/hooks/useFetch'
import useUpdateEffect from 'common/hooks/useUpdateEffect'

const formatResult = list => list.map(te => ({
    routingKey: te.routingKey,
    url: te.url,
    level: te.level,
    instance: te.lastInstance,
    service: te.lastService,
    requestStart: te.lastRequestStart,
    processStart: te.lastProcessStart,
    processEnd: te.lastProcessEnd,
    user: te.lastUser,
    module: te.lastModule,
}))

const DashboardTimeErrors = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(ServicesActions.fetch())
        dispatch(fetchInstances())
    }, [dispatch])

    const [filter, setFilter] = useState({})

    const {
        data: timeErrors = [],
        reload,
    } = useFetch(ApplicationConf.timeError.dashboard(), { method: 'POST', body: filter }, { formatResult })

    useUpdateEffect(() => {
        reload()
    }, [filter])

    return (
        <>
            <TimeErrorFilterFields
                defaultFilter={filter}
                onValidate={setFilter}
            />
            <TimeErrorsTable
                timeErrors={timeErrors}
                reload={reload}
            />
        </>
    )
}

export default DashboardTimeErrors